// „Dokumente" (frontend/src/pages/Documents.tsx + DocumentDetail.tsx) —
// deutsche QUELLE. Texte wörtlich wie zuvor im JSX (die Walks selektieren sie).
//
// Bewusst NICHT hier: der Titel eines aus einem Dokument erzeugten Chats
// (`Über: <Dokument>`). Chat- und Suchoberfläche sind laut docs/i18n.md §5
// ausdrücklich nicht Teil der Umstellung, und der Titel ist gespeicherter
// Inhalt, keine Beschriftung.
export const documents = {
  // ---- Liste (Documents.tsx) ----
  seitenTitel: "Dokumente",
  untertitel: "PDF oder Markdown hochladen",
  dateiZiehen: "Datei hierher ziehen oder klicken",
  dateiTypen: ".pdf oder .md",
  uploadAria: "Dokument (PDF/Markdown) hochladen",
  wirdHochgeladen: "wird hochgeladen …",
  keineDokumente: "Noch keine Dokumente",
  keineDokumenteHinweis: "PDF oder Markdown oben hineinziehen.",
  dateiAuswaehlen: "Datei auswählen",
  tabelleAusDokument: "Tabelle aus Dokument erstellen",
  mitDokumentUnterhalten: "Mit Dokument unterhalten",
  zusammenfassungWirdGeneriert: "Zusammenfassung wird generiert …",
  zusammenfassungFehlgeschlagen: "Zusammenfassung fehlgeschlagen.",

  // Rückmeldungen
  ladenFehlgeschlagen: "Dokumente konnten nicht geladen werden",
  hochgeladenToast: "Hochgeladen",
  embeddingLaeuft: (datei: string) => `${datei} — Embedding läuft im Hintergrund`,
  uploadFehlgeschlagen: "Upload fehlgeschlagen",
  wirklichLoeschen: (titel: string) => `„${titel}" wirklich löschen?`,
  chunksUndVektoren: "Chunks und Vektoren gehen mit.",
  chunksUndVektorenKurz: "Chunks & Vektoren gehen mit.",
  dokumentGeloescht: "Dokument gelöscht",
  loeschenFehlgeschlagen: "Löschen fehlgeschlagen",
  chatErstellungFehlgeschlagen: "Chat-Erstellung fehlgeschlagen",

  // ---- Detail (DocumentDetail.tsx) ----
  laden: "Lade …",
  verarbeitungFertig: "Verarbeitung fertig",
  bilderAnzahl: (n: number) => `${n} Bilder`,
  tabellenAnzahl: (n: number) => `${n} Tabellen`,
  dokumentNichtGefunden: "Dokument nicht gefunden",
  tabelleNichtErstellt: "Tabelle konnte nicht erstellt werden",
  tabellenErstellt: (n: number) => `${n} Tabelle${n === 1 ? "" : "n"} erstellt`,
  extraktionImHintergrund: "Extraktion läuft im Hintergrund.",
  tabellenNichtErstellt: "Tabellen konnten nicht erstellt werden",
  verarbeitungFehlgeschlagen: "Verarbeitung fehlgeschlagen",
  docAiFehler:
    "doc-ai konnte das Dokument nicht extrahieren. Bitte erneut hochladen oder das Original prüfen.",

  aktionen: "Aktionen",
  anpassen: "Anpassen …",
  anpassenTitel: "Spalten & Extraktion selbst anpassen",
  vorschlagWirdVorbereitet: "Tabellen-Vorschlag wird vorbereitet …",
  zusammenfassung: "Zusammenfassung",
  wirdGeneriert: "wird generiert …",
  fehler: "Fehler",
  keine: "(keine)",

  tabellenVorschlaege: "Tabellen-Vorschläge",
  tabellenVorschlag: "Tabellen-Vorschlag",
  alleErstellen: "Alle erstellen",
  wartenAufZusammenfassung: "Zusammenfassung wird noch generiert – bitte kurz warten …",
  dokumentWirdVerarbeitet: "Dokument wird noch verarbeitet …",
  keinVorschlagVerfuegbar: "Noch kein Tabellen-Vorschlag verfügbar",
  weitereOhneSchema: (n: number) =>
    `weitere ${n === 1 ? "Tabelle" : "Tabellen"} ohne Schema-Vorschlag.`,
  // Das Anführungszeichen-Paar „…" steht so (mit geradem Schluss-Zeichen) auch
  // im bisherigen JSX — deshalb escaped statt „schöner" gesetzt.
  schemaSelbstDefinieren: "Über „Anpassen …\" lässt sich dafür selbst ein Schema definieren.",

  erstellteTabellen: "Erstellte Tabellen",
  metadaten: "Metadaten",
  status: "Status",
  bilder: "Bilder",
  tabellen: "Tabellen",
  hochgeladen: "Hochgeladen",
  hochgeladenVon: "Hochgeladen von",
  projekt: "Projekt",
  ansehen: "ansehen",

  // Schema-Karte
  tabelle: "Tabelle",
  zeileIst: (einheit: string) => `Zeile = ${einheit}`,
  spaltenAnzahl: (n: number) => `${n} Spalten`,
  zeilenErwartet: (n: number) => `~${n} Zeilen erwartet`,
  erstellen: "Erstellen",
  tabelleSeite: (seite: number) => `Tabelle S. ${seite}`,
  kiSchema: "KI-Schema",

  // Original-Ansicht
  inhaltExtrahiert: "Inhalt extrahiert & im Chat durchsuchbar",
  inhaltExtrahiertHinweis:
    "Der Text dieses Dokuments liegt vektorisiert in doc-ai und ist über „Mit Dokument unterhalten\" auffindbar. Unten das hochgeladene Original.",
  originalNichtGeladen: (fehler: string) => `Original konnte nicht geladen werden: ${fehler}`,
  ladeOriginal: "Lade Original …",
  inNeuemTab: "In neuem Tab",
  keineVorschau: "Keine Inline-Vorschau für dieses Format — herunterladen zum Öffnen.",

  // Verarbeitungs-Skelett
  docAiVerarbeitet: "doc-ai verarbeitet (Mistral OCR + Captioning) …",
  embeddingsWerdenBerechnet: "Embeddings werden berechnet …",
  wartetAufDocAi: "Wartet auf doc-ai …",
  verarbeitetSeit: (dauer: string) => `verarbeitet seit ${dauer} · typisch 30–180s`,
};

export type DocumentsKatalog = typeof documents;
